import { createFileRoute } from '@tanstack/react-router';
import { TimesheetApprovalConsole } from '@/features/timesheet/ApprovalConsole';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTimesheetApproval } from '@/features/timesheet/mobile/MobileTimesheetApproval';

/**
 * Approvazione rendicontazione (PM): console MaeDesign con azioni inline sulla
 * state machine `BILLING_STATUS` (0–6, nessun ritorno da ≥3). Sostituisce la
 * `ResourceListPage` generica mantenendone le funzioni.
 */
export const Route = createFileRoute('/_app/timesheet/approval')({ component: TimesheetApprovalPage });

/** Selettore mobile/desktop: su telefono la tabella a 10 colonne diventa una lista di card. */
function TimesheetApprovalPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileTimesheetApproval /> : <TimesheetApprovalConsole />;
}
